export default __webpack_public_path__ + "static/media/bai.32039f94.svg";